/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramProductsUserControllerRaiseMutationResponse,
  TelegramProductsUserControllerRaisePathParams,
  TelegramProductsUserControllerRaise400,
  TelegramProductsUserControllerRaise401,
  TelegramProductsUserControllerRaise402,
  TelegramProductsUserControllerRaise404,
} from '../types/TelegramProductsUserControllerRaise.ts';

function getTelegramProductsUserRaiseUrl(id: TelegramProductsUserControllerRaisePathParams['id']) {
  const res = { method: 'PATCH', url: `/api/user/telegram/products/raise/${id}` as const };
  return res;
}

/**
 * {@link /api/user/telegram/products/raise/:id}
 */
export async function telegramProductsUserRaise(
  id: TelegramProductsUserControllerRaisePathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramProductsUserControllerRaiseMutationResponse,
    ResponseErrorConfig<
      | TelegramProductsUserControllerRaise400
      | TelegramProductsUserControllerRaise401
      | TelegramProductsUserControllerRaise402
      | TelegramProductsUserControllerRaise404
    >,
    unknown
  >({ method: 'PATCH', url: getTelegramProductsUserRaiseUrl(id).url.toString(), ...requestConfig });
  return res.data;
}
